<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiFlagCheckered } from "@mdi/js"

export default {
  name: "FlagCheckeredIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiFlagCheckered,
    }
  }
}
</script>
